import styled from 'styled-components/macro'
import { COLORS, BREAKPOINTS } from '../GlobalStyles'

import responsiveness from '../assets/illustrations/responsiveness.svg'
import accessibility from '../assets/illustrations/accessibility.svg'
import style from '../assets/illustrations/style.svg'

export const Values = () => (
  <Wrapper>
    <div className='section-inner values'>
      {/* <h2 className='heading'>[ <b>values</b> ]</h2> */}
      <h3>Responsive · Accessible · Stylish</h3>
      <div className='text'>
        <p className='intro'>
          I believe every app should adapt beautifully, work for everyone, and look great doing it.
        </p>
      </div>
      <div className='grid'>
        <div className='value'>
          <img src={responsiveness} alt='Responsiveness illustration' />
          <h3>Responsive</h3>
          <p>Ensure every interface adapts flawlessly to any screen size.</p>
        </div>

        <div className='value'>
          <img src={accessibility} alt='Accessibility illustration' />
          <h3>Accessible</h3>
          <p>Build for all users by meeting WCAG standards and semantic HTML practices.</p>
        </div>

        <div className='value'>
          <img src={style} alt='Visual design illustration' />
          <h3>Stylish</h3>
          <p>Elevate your brand with clean, cohesive, on-point visual design.</p>
        </div>
      </div>
    </div>
  </Wrapper>
)


const Wrapper = styled.section`
  background: #222;
  color: #f6f6f6;
  .grid {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
    .value {
      background: #fff;
      color: ${COLORS.dark};
      max-width: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 40px 20px;
      border-radius: 15px;
      overflow: hidden;
      img {
        height: 100px;
        margin: 20px;
      }
      h3 {
        color: ${COLORS.medium};
        text-align: center;
        font-size: 1.5rem;
        margin: 20px 0;
      }
    }
  }
  @media only screen and (min-width: ${BREAKPOINTS.tablet}) {
    .grid {
      flex-direction: row;
      flex-wrap: wrap;
      gap: 30px;
      .value {
        img {
          height: 150px;
        }
      }
    }
  }
  @media only screen and (min-width: ${BREAKPOINTS.desktop}) {
    .grid {
      gap: 40px;
      .value {
        padding: 50px 30px;
      }
    }
  }
`
